module.exports = "/images/vendor/desiigner-svg/svg/places/bear.svg?d3ff8ac08d2d1ca90b2c85233b49fa0e";